import packSelect from './form-parts/packSelect';
export default {
    components: [{
            label: 'Select Action',
            key: 'action',
            type: 'select',
            multi: false,
            validate: {
                required: true
            },
            data: {
                values: [{
                        label: 'Simple Action',
                        value: 'simple action'
                    }, {
                        label: 'Notify Email',
                        value: 'notify email'
                    }, {
                        label: 'Notify Text Message',
                        value: 'notify text message'
                    }]
            }
        }, packSelect]
};
